import createTag from '../createTag';
var id = createTag();
export default id;